'use client';

export const addBrowserHistory = (url: URL) => {
  window.history.pushState(undefined, '', url);
};

export const replaceBrowserHistory = (url: URL) => {
  window.history.replaceState(undefined, '', url);
};
